/**
 * Generic list-page toolbar: search slot + filter slot + actions slot.
 *
 * Wraps cleanly on mobile (search spans full width; filters wrap to a
 * new row). Each slot is optional so individual pages compose only what
 * they need.
 */
import { type ReactNode } from "react";

export function Toolbar({
  search,
  filters,
  actions,
}: {
  search?: ReactNode;
  filters?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="mb-3 flex flex-wrap items-center gap-x-3 gap-y-2 [&_input]:bg-card [&_select]:bg-card">
      {search ? <div className="min-w-64 flex-1 sm:max-w-md">{search}</div> : null}
      <div className="hidden flex-1 lg:block" />
      {filters ? <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-xs">{filters}</div> : null}
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export function FilterGroup({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div role="group" aria-label={label} className="flex flex-wrap items-center gap-2">
      <span aria-hidden className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
        {label}
      </span>
      <div className="inline-flex flex-wrap rounded-lg border bg-card p-0.5 shadow-sm">{children}</div>
    </div>
  );
}
